import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import dayjs from 'dayjs'
import { apiPath } from '@/api'
import { fetch_excel } from 'shared/helpers'
import { Message } from 'element-ui'
import { useStore } from '@/store'


export default /*#__PURE__*/_defineComponent({
  __name: 'Dashboard',
  setup(__props) {

const store = useStore()
const hideDashboard = computed(() => store.getters.hideDashboard)

const exportItems = ref([
  {
    type: 'monthly',
    buttonLabel: '导出月报表',
    dialogTitle: '月报表导出',
    apiEndpoint: '/export_monthly_report',
    showDialog: false,
    exporting: false,
    selectedMonth: null,
  },
  {
    type: 'income',
    buttonLabel: '导出月收入报表',
    dialogTitle: '月收入报表导出',
    apiEndpoint: '/export_monthly_income_report',
    showDialog: false,
    exporting: false,
    selectedMonth: null,
  },
  {
    type: 'treat',
    buttonLabel: '导出月套餐明细',
    dialogTitle: '月套餐明细导出',
    apiEndpoint: '/export_monthly_treat_package_record',
    showDialog: false,
    exporting: false,
    selectedMonth: null,
  },
  {
    type: 'summary',
    buttonLabel: '导出月运营报表',
    dialogTitle: '月运营报表导出',
    apiEndpoint: '/export_monthly_summary_report',
    showDialog: false,
    exporting: false,
    selectedMonth: null,
  },
  {
    type: 'balance_change',
    buttonLabel: '导出余额明细',
    dialogTitle: '余额明细导出',
    apiEndpoint: '/export_balance_change_records',
    showDialog: false,
    exporting: false,
    selectedMonth: null,
  },
])

const exportReport = item => {
  if (!item.selectedMonth) {
    Message.error('请选择月份')
    return
  }
  const date = dayjs(item.selectedMonth)
  item.exporting = true
  fetch_excel(
    apiPath + item.apiEndpoint,
    { date: date.format('YYYY-MM-DD') },
    item.dialogTitle
  ).finally(() => {
    item.exporting = false
  })
}

return { __sfc: true,store, hideDashboard, exportItems, exportReport }
}

})